import { FC, useMemo } from "react";
import { useEventsTypes } from "@pages/makeEvent/steps-components/eventType-component/useEventsTypes";
import InputSelect from "@common/ui-kit/inputs/input_select";
import { EventTypeSelection } from "@pages/makeEvent/steps-components/eventType-component/types.ts";
import { EventTypeComponentProps } from '@pages/makeEvent/types';
import { useAppDispatch, useAppSelector } from "@app/hooks";
import { selectEventType } from "@pages/makeEvent/slice/selectors";
import { apply } from "@app/data/createEvent/createEventSlice";
import { setEventType } from "@pages/makeEvent/slice/MakeEventSlice";
import _ from "lodash";


const fieldName = "event_type_id" as const

const EventTypeComponent: FC<EventTypeComponentProps> = ({ formik, setValidValue }) => {
	const dispatch = useAppDispatch();
	const eventTypeInfo = useAppSelector(selectEventType);
	const { eventTypesList, isLoading: EventsIsLoading } = useEventsTypes();

	const eventTypeChange = (newValue: EventTypeSelection) => {
		const { value } = newValue;
		formik.setFieldValue(fieldName, value);

		const valueToApply = _.isNumber(value) ? value : null
		setValidValue(valueToApply)
		
		dispatch(setEventType(newValue));
		dispatch(apply({ event_type_id: valueToApply }));
	};

	const eventTypeOptions = useMemo(() =>
		eventTypesList.map(type => ({
			value: type.id,
			label: type.type_name,
		})), [eventTypesList]
	)

	return (
		<InputSelect
			isLoading={EventsIsLoading}
			onChange={eventTypeChange}
			value={eventTypeInfo}
			options={eventTypeOptions}
			placeholder={"Выберите тип события"}
			defaultInputValue={""}
			errorText={null}
			handleChange={() => {
			}}
			name={fieldName}
			onBlur={formik.handleBlur}
			type={""}
		/>
	)
}

export default EventTypeComponent;